import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isObject, isSet } from "../../utils/commonUtils";
import FormInputs from "../../components/UI/FormInputs";
import PatientFormService from "../../services/PatientFormService";
import ValidationForm from "./ValidationForm";
import WithRoutify from "../../hoc/WithRoutify";
import WithRouter from "../../hoc/WithRouter";
import { acl_check } from "../../utils/aclUtils";
import { useDispatch } from "react-redux";
import { OK } from "../../utils/constant";
import { applyPatientSessionAuthFromApiResponse } from "../../utils/patientSessionAuth";

const VerificationFormLogin = (props) => {
    const {Loader}=props;
    const [formData, setFormData] = useState({});
    const [validation, setValidation] = useState({});
    const query = new URLSearchParams(useLocation().search);
    const [step,setStep]=useState(1);
    const [selectedMethod,setSelectedMethod]=useState('sms')
    const isPhoneValidation=query.get('phone')=='true'?true:false
    const [isValidForm,setValidForm]=useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const changeHandler = (fieldName, value) => {
        setValidation({ ...validation, [fieldName]: '' })
        setFormData({ ...formData, [fieldName]: value });
    }
    const submitHandler = async () => {
        const payload = {
            isPhoneValidation: selectedMethod === "sms",
            step: step,
            visit_id: query.get("visit_id"),
            phone: formData.phone || "",
            email: formData.email || "",
            code: formData.code,
        };
        let updateValidation = { ...validation };
        Loader(true);
        const data = await PatientFormService.patientFormLogin_md(payload);
        Loader(false);

        if (data.status && data.status === "ERROR") {
            if (isObject(data.data)) {
                for (let key in data.data) {
                    updateValidation = {
                        ...updateValidation,
                        [key]: data.data[key].join(","),
                    };
                }
            } else {
                props.Toast.error(data.data);
            }
            if (Object.keys(updateValidation).length > 0) {
                setValidation(updateValidation);
            }
        } else if (step === 2) {
            if (data?.code !== OK) {
                props.Toast.error(typeof data?.data === "string" ? data.data : "Verification failed.");
                return;
            }
            const applied = await applyPatientSessionAuthFromApiResponse(data, dispatch);
            if (!applied) {
                props.Toast.error("Verification succeeded but session could not be started. Try again or contact support.");
                return;
            }
            const profileData = data?.data?.userProfile;
            if (!profileData) {
                props.Toast.error("Verification succeeded but profile was missing. Try again or contact support.");
                return;
            }
            const { permissions, is_multiple_organization, role, employer_login } = profileData;
            let redirectUrl = "/dashboard";
            if (role === "employer_admin" || employer_login === true) {
                redirectUrl = "/dashboard";
            } else if (isSet(is_multiple_organization, false) === true && acl_check(permissions, "organization-list") === true) {
                redirectUrl = "/organisation";
            } else if (acl_check(permissions, "dashboard-list") === true) {
                redirectUrl = "/dashboard";
            } else if (acl_check(permissions, "appointment-list") === true) {
                redirectUrl = "/appointments";
            } else if (acl_check(permissions, "company-list") === true) {
                redirectUrl = "/company";
            } else if (acl_check(permissions, "clinic-list") === true) {
                redirectUrl = "/clinics";
            } else if (acl_check(permissions, "employee-list") === true) {
                redirectUrl = "/employee";
            } else if (acl_check(permissions, "visits-list") === true) {
                redirectUrl = "/visits";
            } else if (acl_check(permissions, "lab-list") === true) {
                redirectUrl = "/labs";
            } else if (acl_check(permissions, "user-list") === true) {
                redirectUrl = "/users";
            } else if (acl_check(permissions, "role-list") === true) {
                redirectUrl = "/roles";
            }
            const redirectPath = props.location.pathname.includes("send-questionnaire")
                ? `/result/physical-drug-screens${props.location.search}`
                : redirectUrl;
            navigate(redirectPath);
        } else {
            setStep(step + 1);
        }
    };
    const handleMethodChange=(e,val)=>{
      setSelectedMethod(val)
      setValidation({ })
      setFormData({});
    }
    return (
        <>
        {
          isValidForm == false ?
            <ValidationForm
              setValidForm={setValidForm} 
            />
            :
            <></>
        }
        
            <>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 min-vh-100 d-flex flex-column justify-content-center mx-auto">
                        <div className="card sh_loginCard border-0 rounded-lg mt-5">
                            <div className="card-header justify-content-center">
                                <div className="text-center sh_loginLogo">
                                    <img src="/assets/img/snap-logo-new.png" className=" w-100" alt="Logo" />
                                </div>
                            </div>
                            <div className="card-body">
                                <h6 className="text-lg f-500">Verification</h6>
                                <div className=" d-flex">
                                {step===1 && ['sms','email'].map((item,index)=>{
                                  return(
                                    <>
                                      <div className="form-check mr-2 pl-0" key={index}><FormInputs id={`${item}_${index}`} type="Radio" name="auth_method" className="cursor-pointer" value={item===selectedMethod?true:false} changeHandler={(e) => handleMethodChange(e, item)} /> <label htmlFor={`${item}_${index}`}>{item}</label>

                                      </div>
                                    </>
                                  )
                                })}
                                </div>
                                <form className="sh_loginCre" onSubmit={(e) => { e.preventDefault(); submitHandler(); }}> 
                                    {
                                        step===1?
                                        <>
                                        <FormInputs
                                        type={selectedMethod==='sms'?'Phone':''}
                                        className="form-control form-control-fields"
                                        placeholder={selectedMethod==='sms'?'Enter Phone Number':'Enter Email Address'}
                                        name={selectedMethod==='sms'?'phone':'email'}
                                        changeHandler={(value, e) => { changeHandler(selectedMethod==='sms'?'phone':'email', value) }}
                                        value={formData[selectedMethod==='sms'?'phone':'email']}

                                    />
                                      {isSet(validation[query.get('patient')=='true'?'phone':'email']) !== "" ? (
                                            <span className="text-danger m-1">
                                              {isSet(validation[selectedMethod==='sms'?'phone':'email'], "")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                    <div className="d-flex align-items-start mt-3">
                                        <i className="fas fa-info-circle pt-2 fa-lg"></i>
                                        <p className="font-weight-normal text-gray-600 text-sm pl-2">
                                            {`Please enter your ${selectedMethod==='sms' ? 'phone number' : 'email address'} to receive a verification code. This code will be used to verify your identity and secure your account.`}  
                                        </p>
                                    </div>
                                        </>
                                        :
                                        <>
                                        <FormInputs
                                        type=""
                                        className="form-control form-control-fields"
                                        placeholder="Enter Code"
                                        name="code"
                                        changeHandler={(value, e) => { changeHandler('code', value) }}
                                        value={formData['code']}

                                    />
                                        {isSet(validation['code'], "") !== "" ? (
                                            <span className="text-danger m-1">
                                              {isSet(validation['code'], "")}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                            <div className="d-flex align-items-start mt-3">
                                        <i className="fas fa-info-circle pt-2 fa-lg"></i>
                                        <p className="font-weight-normal text-gray-600 text-sm pl-2">
                                            {`Please check your ${selectedMethod==='sms' ? 'text message' : 'email address'} for the Verification Code and enter it above.`} 
                                        </p>
                                    </div>
                                    </>
                                    }
                                    <div className="d-flex align-items-center justify-content-center sh_loginButtons">
                                        <a class="btn btn-primary btn-user"  onClick={()=>submitHandler()}>Submit</a>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
        </>
    );
};

export default WithRouter(WithRoutify(VerificationFormLogin));
